import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth, ROUTE_ACCESS } from "@/contexts/AuthContext";
import { EmpresaProvider, useEmpresa } from "@/contexts/EmpresaContext";
import Layout from "@/components/Layout";
import BrowserCompatBanner from "@/components/BrowserCompatBanner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Empresas from "@/pages/Empresas";
import Centros from "@/pages/Centros";
import Empleados from "@/pages/Empleados";
import Horarios from "@/pages/Horarios";
import Jornadas from "@/pages/Jornadas";
import Incidencias from "@/pages/Incidencias";
import Checadores from "@/pages/Checadores";
import Reportes from "@/pages/Reportes";
import Configuracion from "@/pages/Configuracion";
import Auditoria from "@/pages/Auditoria";
import Usuarios from "@/pages/Usuarios";
import CalendarioLaboral from "@/pages/CalendarioLaboral";
import Suscripcion from "@/pages/Suscripcion";
import Escuela from "@/pages/Escuela";
import CargaDocente from "@/pages/CargaDocente";
import AsistenciaDocente from "@/pages/AsistenciaDocente";
import Portal from "@/pages/Portal";
import Perfil from "@/pages/Perfil";
import ForgotPassword from "@/pages/ForgotPassword";

function PantallaCarga(props) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 text-brand-accent" {...props}>
      <img src="/brand/monograma.png" alt="" className="w-14 h-14 animate-pulse" />
      Cargando…
    </div>
  );
}

function ProtectedRoute() {
  const { user, loading } = useAuth();
  if (loading) {
    return <PantallaCarga data-testid="auth-loading" />;
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <PantallaCarga />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "empleado" ? "/app/portal" : "/app/dashboard"} replace />;
}

function RoleRoute({ access, children }) {
  const { user } = useAuth();
  const { esEscuela, listo } = useEmpresa();
  // Solo la ruta de escuela depende del tipo de la empresa activa; las demás no esperan.
  if (["escuela", "cargaDocente", "asistenciaDocente"].includes(access) && !listo) return <PantallaCarga />;
  const allowed = ROUTE_ACCESS[access] ? ROUTE_ACCESS[access](user, { esEscuela }) : true;
  if (!allowed) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <BrowserCompatBanner />
      <AuthProvider>
        <EmpresaProvider>
        <Routes>
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/app" element={<Layout />}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<RoleRoute access="dashboard"><Dashboard /></RoleRoute>} />
              <Route path="portal" element={<RoleRoute access="portal"><Portal /></RoleRoute>} />
              <Route path="perfil" element={<RoleRoute access="perfil"><Perfil /></RoleRoute>} />
              <Route path="empresas" element={<RoleRoute access="empresas"><Empresas /></RoleRoute>} />
              <Route path="centros" element={<RoleRoute access="centros"><Centros /></RoleRoute>} />
              <Route path="empleados" element={<RoleRoute access="empleados"><Empleados /></RoleRoute>} />
              <Route path="horarios" element={<RoleRoute access="horarios"><Horarios /></RoleRoute>} />
              <Route path="jornadas" element={<RoleRoute access="jornadas"><Jornadas /></RoleRoute>} />
              <Route path="incidencias" element={<RoleRoute access="incidencias"><Incidencias /></RoleRoute>} />
              <Route path="checadores" element={<RoleRoute access="checadores"><Checadores /></RoleRoute>} />
              <Route path="reportes" element={<RoleRoute access="reportes"><Reportes /></RoleRoute>} />
              <Route path="configuracion" element={<RoleRoute access="configuracion"><Configuracion /></RoleRoute>} />
              <Route path="calendario" element={<RoleRoute access="calendario"><CalendarioLaboral /></RoleRoute>} />
              <Route path="auditoria" element={<RoleRoute access="auditoria"><Auditoria /></RoleRoute>} />
              <Route path="usuarios" element={<RoleRoute access="usuarios"><Usuarios /></RoleRoute>} />
              <Route path="suscripcion" element={<RoleRoute access="suscripcion"><Suscripcion /></RoleRoute>} />
              <Route path="escuela" element={<RoleRoute access="escuela"><Escuela /></RoleRoute>} />
              <Route path="carga-docente" element={<RoleRoute access="cargaDocente"><CargaDocente /></RoleRoute>} />
              <Route path="asistencia-docente" element={<RoleRoute access="asistenciaDocente"><AsistenciaDocente /></RoleRoute>} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </EmpresaProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
